<template>
<w-sliding-popup ref="slidingPopup" :title="title" width="700px" @close="closed" class="widget-setting-popup">
  <div class="widget-setting-popup-content-wrapper" slot="content">
    <el-steps :active="activeStep"  finish-status="success">
      <el-step title="기본 정보"></el-step>
      <el-step title="대상 설정"></el-step>
      <el-step title="화면 설정"></el-step>
    </el-steps>
    <component class="widget-setting-popup-content" :is="widgetSettingView" ref="settingWidget" v-model="widget" :active-step="activeStep"/>
  </div>
  <el-row slot="footer">
    <div v-show="activeStep === 1">
      <el-col :span="24">
        <el-row type="flex" justify="end">
          <el-button class="mr-r4" size="large" type="solid" @click="nextStep">다음</el-button>
          <el-button size="large" @click="close">취소</el-button>
        </el-row>
      </el-col>
    </div>
    <div v-show="activeStep === 2">
      <el-col :span="12">
        <el-row type="flex" justify="start">
          <el-button size="large" @click="prevStep"><i class="fal fa-arrow-left mr-r2"></i>이전 단계</el-button>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="end">
          <el-button class="mr-r4" size="large" type="solid" @click="nextStep">다음</el-button>
          <el-button size="large" @click="close">취소</el-button>
        </el-row>
      </el-col>
    </div>
    <div v-show="activeStep === 3">
      <el-col :span="12">
        <el-row type="flex" justify="start">
          <el-button size="large" @click="prevStep"><i class="fal fa-arrow-left mr-r2"></i>이전 단계</el-button>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="end">
          <el-button class="mr-r4" size="large" type="solid" @click="save">완료</el-button>
          <el-button size="large" @click="close">취소</el-button>
        </el-row>
      </el-col>
    </div>
  </el-row>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import cloneDeep from 'lodash/cloneDeep';

import DashboardConst from '@/constants/dashboard';

export default {
  name: 'WWidgetSettingPopup',
  components: {
  },
  data() {
    return {
      activeStep: 1,
      widget: null,
      isNew: false,
    };
  },
  computed: {
    widgetSettingView() {
      return (this.widget && this.$store.getters.getWidgetSettingComponent[this.widget.widgetTemplId]) || null;
    },
    title() {
      const widgetTempl = this.widget && this.$store.getters.getWidgetTempl[this.widget.widgetTemplId];
      return `${widgetTempl ? widgetTempl.widgetTemplName : ''} 위젯 설정`;
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.WIDGET_EDIT, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.WIDGET_EDIT, this.open);
  },
  methods: {
    /**
     * 슬라이드 팝업창 열기
     * @author KangBonghun(toto1323)
     * @param  {[type]}  widget 위젯 데이터
     * @param  {Boolean} isNew  신규 위젯 여부
     * @return {[type]}         [description]
     */
    open(widget, isNew) {
      this.activeStep = 1;
      this.widget = cloneDeep(widget);
      this.isNew = isNew;
      this.$refs.slidingPopup.open();
    },
    /**
     * 슬라이드 팝업창 닫기
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    closed() {
      // 신규 위젯인데 저장하지 않고 그냥 닫으면 위젯을 삭제한다.
      if (this.isNew) {
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_DELETE, this.widget.widgetId);
      }

      this.activeStep = 1;
      this.widget = null;
      this.isNew = false;
    },
    /**
     * 위젯 설정 내용 저장
     * @auth
     */
    save() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_APPLY_SET, this.widget);
      this.isNew = false;
      this.close();
    },
    /**
     * 전 단계로 이동
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    prevStep() {
      this.activeStep -= 1;
    },
    /**
     * 다음 단계로 이동
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    nextStep() {
      const settingWidget = this.$refs.settingWidget;

      // 유효성 검사
      if (settingWidget && settingWidget.checkValidation) {
        const validateInfo = settingWidget.checkValidation();

        if (validateInfo.isValide) {
          this.activeStep += 1;
        } else {
          this.$message(msgUtil.getCustomMsgData(validateInfo.message));
        }
      }
    },
  },
};
</script>

<style lang="scss">
.widget-setting-popup {
  .el-form--label-top .el-form-item__label {
    padding-bottom: 7px;
  }

  .el-scrollbar__view {
    height: 100%;
  }

  .body-content {
    height: 100%;
    padding: 25px 25px 25px 25px !important;
  }

  // .el-form-item--mini.el-form-item,
  // .el-form-item--small.el-form-item {
  //   margin-bottom: 15px;
  // }

  .tree-checkbox .el-tree-node__content {
    // -webkit-transition: background-color .25s ease;
    // transition: background-color .25s ease;
    background-color: transparent !important;
    // cursor: default;

    &:hover {
      background-color: #f1f2f5 !important //$vlightgray
    }
  }
  .widget-setting-popup-content-wrapper {
    height: 100% !important;
    /* height: calc(100% - 16px) !important; */
  }
  .widget-setting-popup-content {
    height: calc(100% - 117px);
    position: relative;
    overflow-y: auto;
    margin-top: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/WidgetSettingPopup.vue